/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


/**
 * ===================================================================
 * SCRIPT: Unified Product Validation Script (v9 - Polling Fix)
 * ===================================================================
 * This single script handles all product page validation and fixes.
 *
 * 1. [UNIVERSAL] Hides the canvas builder, fixes the main product image,
 * then fades the canvas back in to prevent the "flicker".
 *
 * 2. [CONDITIONAL] Detects if TPO app inputs exist. If they do, it:
 * a. Syncs the app's size-quantity fields.
 * b. Validates the form on 'submit' for all required fields.
 */
document.addEventListener('DOMContentLoaded', function() {
  
  // --- 1. DEFINE YOUR SELECTORS ---
  const TPO_CONTAINER_SELECTOR = '.tpo_option-set-container';
  const TPO_SIZE_INPUTS_SELECTOR = '.tpo_option-input.tpo_quantity';
  const TPO_ALL_INPUTS_SELECTOR = '.tpo_option-set-container .tpo_option-input, .tpo_option-set-container .tpo-checkbox-button, .tpo_option-set-container .tpo_radio-button';
  const TPO_CANVAS_BUILDER_SELECTOR = '.tpo_canvas_builder'; // For flicker fix

  const ATC_FORM_SELECTOR = 'form[action*="/cart/add"]:not([id*="installment"])';
  const MAIN_QUANTITY_INPUT_SELECTOR = `${ATC_FORM_SELECTOR} input[name="quantity"]:not(.tpo_option-input)`;
  
  // Theme's product gallery
  const PRODUCT_IMAGES_CONTAINER_SELECTOR = 'product-images';
  const FIRST_MEDIA_ITEM_SELECTOR = '[data-media-id]:first-child';
  
  // Theme's variant inputs
  const THEME_VARIANT_INPUTS_SELECTOR = '[data-product-variants] input[name^="options"]';
  
  // This is the parent container where the error message will be injected.
  const ERROR_MESSAGE_PARENT_SELECTOR = '.product__submit.product__submit--spb';
  const FORM_ERROR_CONTAINER_ID = 'pd-form-error-message'; // The ID of our new error div
  
  // --- 2. STATE ---
  let mainForm = null;
  let pdCanvasIsHidden = false; // Flag to track if the canvas has been hidden

  /**
   * Fades the canvas builder back in.
   */
  function showCanvas() {
    const canvasBuilder = document.querySelector(TPO_CANVAS_BUILDER_SELECTOR);
    if (canvasBuilder) {
      canvasBuilder.style.transition = 'opacity 0.3s ease';
      canvasBuilder.style.opacity = '1';
      console.log('Image Fix: Fading canvas builder in.');
    } else {
      console.warn('Image Fix: showCanvas() ran, but canvas builder was not found.');
    }
  }

  /**
   * [NEW] Polls until the canvas is hidden, then reveals it.
   */
  let revealAttempts = 0;
  function revealCanvasWhenReady() {
    if (pdCanvasIsHidden) {
      // SUCCESS: The canvas was found and hidden. It's safe to show it.
      console.log('Image Fix: Canvas is hidden. Revealing now.');
      showCanvas();
    } else if (revealAttempts < 5) {
      // RETRY: The canvas isn't hidden yet. Wait and try again.
      revealAttempts++;
      console.log(`Image Fix: Waiting for canvas to hide... (Attempt ${revealAttempts})`);
      setTimeout(revealCanvasWhenReady, 1000); // Wait 1 second
    } else {
      // FAILSAFE: Waited 5 seconds, canvas still not found/hidden.
      // Show it anyway to prevent it from being permanently hidden.
      console.warn('Image Fix: Timed out waiting for canvas. Forcing reveal.');
      showCanvas();
    }
  }

  /**
   * Forces the main product image to display, then starts reveal polling.
   */
  function fixInitialImage() {
    const productImagesContainer = document.querySelector(PRODUCT_IMAGES_CONTAINER_SELECTOR);
    const firstMediaItem = productImagesContainer ? productImagesContainer.querySelector(FIRST_MEDIA_ITEM_SELECTOR) : null;

    if (firstMediaItem) {
      const firstMediaId = firstMediaItem.getAttribute('data-media-id');
      console.log(`Image Fix: Forcing media ID: ${firstMediaId}`);
      
      firstMediaItem.dispatchEvent(
        new CustomEvent('theme:media:select', {
          bubbles: true,
          detail: { id: firstMediaId }
        })
      );
      
      // Start the polling function to reveal the canvas
      revealCanvasWhenReady(); 

    } else {
      console.warn('Image Fix: Could not find firstMediaItem to fix image.');
      // If we fail, still try to reveal the canvas
      revealCanvasWhenReady();
    }
  }

  // --- Validation Functions (Unchanged) ---

  function getTotalQuantity() {
    const sizeInputs = document.querySelectorAll(TPO_SIZE_INPUTS_SELECTOR);
    let totalQuantity = 0;
    
    sizeInputs.forEach(input => {
      if (!input.disabled) {
        const value = parseInt(input.value, 10);
        if (!isNaN(value) && value > 0) {
          totalQuantity += value;
        }
      }
    });
    return totalQuantity;
  }

  function areAppFieldsValid() {
    const requiredFields = document.querySelectorAll(`${TPO_CONTAINER_SELECTOR} [data-required="1"]`);
    let allValid = true;

    if (requiredFields.length === 0) {
      return true; 
    }

    requiredFields.forEach(field => {
      const isVisible = field.closest('.tpo_option-container.tpo_hidden') === null;
      const hasValue = field.value && field.value.trim() !== '';
      
      if (isVisible && !hasValue) {
        allValid = false;
      }
    });
    return allValid;
  }

  function updateError(message) {
    const errorContainer = document.getElementById(FORM_ERROR_CONTAINER_ID);
    if (errorContainer) {
      if (message) {
        errorContainer.innerHTML = `<p class="pd-form-error-message" style="color: var(--COLOR-ERROR, #D92D20); margin-bottom: 10px;">${message}</p>`;
        errorContainer.style.display = 'block';
      } else {
        errorContainer.innerHTML = '';
        errorContainer.style.display = 'none';
      }
    }
  }

  function handleFormInput() {
    updateError(null);
    
    const tpoInputsExist = document.querySelectorAll(TPO_SIZE_INPUTS_SELECTOR).length > 0;
    if (tpoInputsExist) {
      const mainQtyInput = document.querySelector(MAIN_QUANTITY_INPUT_SELECTOR);
      const totalQuantity = getTotalQuantity();

      if (mainQtyInput) {
        mainQtyInput.value = totalQuantity;
      }
    }
  }

  /**
   * The main validation function that runs when the user tries to SUBMIT.
   */
  function handleFormSubmit(event) {
    const variantSelected = document.querySelector(`${THEME_VARIANT_INPUTS_SELECTOR}:checked`) !== null;
    
    // 1. [UNIVERSAL] Check if a theme variant is selected
    if (!variantSelected) {
      console.log('Validation: SUBMIT FAILED - No variant selected.');
      event.preventDefault(); 

      // --- MODIFIED: Find the first option's name ---
      let errorText = 'Please select an option'; // Default fallback text
      const firstOptionNameEl = document.querySelector('[data-product-variants] .radio__legend__option-name');
      
      if (firstOptionNameEl && firstOptionNameEl.textContent.trim() !== '') {
        errorText = `Select ${firstOptionNameEl.textContent.trim()}`; // Prepend "Select "
      }
      // --- END MODIFICATION ---

      updateError(errorText);
      return;
    }
    
    const tpoInputsExist = document.querySelectorAll(TPO_SIZE_INPUTS_SELECTOR).length > 0;
    
    if (tpoInputsExist) {
      // 2. [TPO ONLY] Check if total quantity is > 0
      const totalQuantity = getTotalQuantity();
      if (totalQuantity === 0) {
        console.log('Quantity Sync: SUBMIT FAILED - Total quantity is 0.');
        event.preventDefault(); 
        updateError('Select Size/Quantity');
        return;
      }

      // 3. [TPO ONLY] Check if TPO app's required fields are valid
      if (!areAppFieldsValid()) {
        console.log('Quantity Sync: SUBMIT FAILED - App fields are invalid.');
        event.preventDefault(); 
        updateError('Please fill all required options');
        return;
      }
    }

    console.log('Validation: All checks passed. Submitting...');
    updateError(null); 
  }

  /**
   * Finds and attaches listeners to all inputs.
   */
  function initValidationListeners() {
    const themeInputs = document.querySelectorAll(THEME_VARIANT_INPUTS_SELECTOR);
    mainForm = document.querySelector(ATC_FORM_SELECTOR);
    const errorMessageParent = document.querySelector(ERROR_MESSAGE_PARENT_SELECTOR);

    if (themeInputs.length > 0 && mainForm && errorMessageParent) {
      console.log('Validation: Found theme inputs, form, and error message container.');

      if (!document.getElementById(FORM_ERROR_CONTAINER_ID)) {
        const errorContainer = document.createElement('div');
        errorContainer.id = FORM_ERROR_CONTAINER_ID;
        errorContainer.style.color = 'var(--COLOR-ERROR, #D92D20)';
        errorContainer.style.marginBottom = '10px';
        errorContainer.style.display = 'none';
        errorMessageParent.prepend(errorContainer);
      }

      themeInputs.forEach(input => {
        if (input.dataset.listenerAttached) return;
        input.addEventListener('change', handleFormInput);
        input.dataset.listenerAttached = 'true';
      });
      
      mainForm.addEventListener('submit', handleFormSubmit);
      
      if (!attachTpoListeners()) {
        const tpoLoadObserver = new MutationObserver(function(mutationsList, obs) {
          if (document.querySelector(TPO_SIZE_INPUTS_SELECTOR)) {
            console.log('Quantity Sync: App inputs detected in DOM.');
            if (attachTpoListeners()) {
              obs.disconnect(); 
            }
          }
        });
        tpoLoadObserver.observe(document.body, { childList: true, subtree: true });
      }
      return true;
    }
    return false;
  }

  /**
   * Attaches listeners specifically to the TPO app inputs.
   */
  function attachTpoListeners() {
    const allTpoInputs = document.querySelectorAll(TPO_ALL_INPUTS_SELECTOR);
    
    if (allTpoInputs.length > 0) {
      console.log(`Quantity Sync: Found ${allTpoInputs.length} app inputs. Attaching listeners...`);
      allTpoInputs.forEach(input => {
        if (input.dataset.listenerAttached) return;
        input.addEventListener('input', handleFormInput);
        input.addEventListener('change', handleFormInput);
        input.dataset.listenerAttached = 'true';
      });
      handleFormInput();
      return true;
    }
    return false;
  }

  // --- 3. OBSERVERS (to wait for elements to load) ---
  
  // Observer 1: Image Fix (Runs first and independently)
  const imageObserver = new MutationObserver(function(mutationsList, obs) {
    const gallery = document.querySelector(PRODUCT_IMAGES_CONTAINER_SELECTOR);
    if (gallery) {
      console.log('Validation: Product gallery detected. Running image fix.');
      fixInitialImage();
      obs.disconnect(); // This observer is done
    }
  });

  // Observer 2: Validation Logic (Waits for all form parts)
  const validationObserver = new MutationObserver(function(mutationsList, obs) {
    const themeInputs = document.querySelector(THEME_VARIANT_INPUTS_SELECTOR);
    const form = document.querySelector(ATC_FORM_SELECTOR);
    const errorParent = document.querySelector(ERROR_MESSAGE_PARENT_SELECTOR);

    if (themeInputs && form && errorParent) {
      console.log('Validation: All required THEME elements detected in DOM.');
      if (initValidationListeners()) {
        obs.disconnect(); // This observer is done
      }
    }
  });

  // Observer 3: Canvas Hiding (Runs immediately)
  const canvasBuilderObserver = new MutationObserver(function(mutationsList, obs) {
    const canvasBuilder = document.querySelector(TPO_CANVAS_BUILDER_SELECTOR);
    if (canvasBuilder) {
      console.log('Image Fix: Canvas Builder detected. Hiding for flicker fix.');
      canvasBuilder.style.opacity = '0'; // Hide it
      canvasBuilder.style.transition = 'none'; // Prevent fade-out
      pdCanvasIsHidden = true; // --- SET THE FLAG ---
      obs.disconnect(); // This observer is done
    }
  });

  // --- 4. START OBSERVERS ---
  
  // Start all observers
  imageObserver.observe(document.body, { childList: true, subtree: true });
  validationObserver.observe(document.body, { childList: true, subtree: true });
  canvasBuilderObserver.observe(document.body, { childList: true, subtree: true });
  
  // --- 5. REMOVED FALLBACK CALLS ---
  // We now rely *only* on the observers to run these functions
  // when the elements are actually present.

});

  

//******************************** */
  // Apply alpha mask to live preview design 

function applyAlphaMask() {
  // 1. Locate the dynamic elements
  const canvasWrapper = document.querySelector('.tpo_canvas_builder');
  const activeImageContainer = document.querySelector('.product__slide.media--active');

  if (!canvasWrapper || !activeImageContainer) {
    console.warn("AlphaMask DEBUG: applyAlphaMask() exited. Required wrappers not found.", { canvasWrapper, activeImageContainer });
    return;
  }

  // 2. Get the specific elements required
  // The 'konvajs-content' div is the direct parent of the canvases
  const konvaContent = canvasWrapper.querySelector('.konvajs-content');
  if (!konvaContent) {
    console.warn("AlphaMask DEBUG: '.konvajs-content' not found inside builder.");
    return;
  }

  const allCanvases = konvaContent.querySelectorAll('canvas');
  
  // Ensure the second canvas exists (it is the design layer)
  const designCanvas = allCanvases[1]; 
  const productImage = activeImageContainer.querySelector('img');

  if (!designCanvas || !productImage) {
    console.warn("AlphaMask DEBUG: Design canvas (canvas:nth-child(2)) or product img not found.");
    return;
  }
  
  // Use a safer check for the image source (currentSrc is the rendered URL)
  const productImageURL = productImage.currentSrc || productImage.src;
  
  if (!productImageURL || productImageURL.includes('placeholder')) {
      console.warn("AlphaMask DEBUG: Image URL is empty or a placeholder.");
      return;
  }

  // 3. Apply the CSS Masking Properties
  // The mask-image property uses the product photo URL. The browser reads the alpha 
  // channel (transparency) of this PNG to define the shape of the canvas.
  
  const maskValue = `url('${productImageURL}')`;

  // Check if the mask is already set to this URL to avoid redundant style changes
  if (designCanvas.style.maskImage === maskValue) {
    console.log("AlphaMask DEBUG: Mask is already set. No change needed.");
    return;
  }
  
  // Set the mask properties
  designCanvas.style.maskImage = maskValue;
  designCanvas.style.maskSize = 'cover';
  designCanvas.style.maskPosition = 'center';

  // Apply WebKit prefixes for cross-browser compatibility (Chrome, Safari)
  designCanvas.style.webkitMaskImage = maskValue;
  designCanvas.style.webkitMaskSize = 'cover';
  designCanvas.style.webkitMaskPosition = 'center';

  console.log(`SUCCESS: Alpha mask applied to CANVAS #2. URL: ${productImageURL}`);
}

// ===================================================================
// MutationObserver Setup (The Engine)
// ===================================================================

let canvasBuilderObserver = null;
let mediaChangeObserver = null;
let maskDelayTimer = null; // Timer to manage delays

function setDelayedMask() {
    // Clear any existing timer to avoid multiple redundant calls
    if (maskDelayTimer) clearTimeout(maskDelayTimer);

    // Set a delay to ensure external resources are stable
    // Increased to 350ms for extra safety on slow networks or complex renders
    maskDelayTimer = setTimeout(applyAlphaMask, 350); 
}

function observeMediaChanges() {
  // Use the custom element tag <product-images> as the observer root
  const mediaContainer = document.querySelector('product-images'); 

  if (mediaContainer && !mediaChangeObserver) {
    console.log("LOG: Activating Media Change Observer on <product-images>.");
    
    mediaChangeObserver = new MutationObserver(function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        
        // This is the most reliable event: when the 'class' attribute of a 
        // .product__slide changes (e.g., 'media--active' is added/removed)
        if (mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target.classList.contains('product__slide')) {
           setDelayedMask(); // Use the new delayed function
           return; // Stop processing other mutations in this batch
        }
      }
    });

    // Start observing attributes on all descendants of the media container
    mediaChangeObserver.observe(mediaContainer, { 
      attributes: true, 
      subtree: true, 
      attributeFilter: ['class'] // We only care about class changes
    });
  } else if (!mediaContainer) {
      console.error("AlphaMask FATAL: Could not find <product-images> container to observe.");
  }
}

document.addEventListener('DOMContentLoaded', function() {
  console.log('LOG: DOM loaded. Initial scan and setup observers...');

  // --- OBSERVE THE BODY FOR THE CANVAS BUILDER ---
  // We must wait for the canvas builder to be injected by the app.
  
  canvasBuilderObserver = new MutationObserver(function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          // Check if the added node IS the canvas builder or CONTAINS it
          if (node.nodeType === 1 && (node.classList.contains('tpo_canvas_builder') || node.querySelector('.tpo_canvas_builder'))) {
            
            console.log('SUCCESS: Canvas Builder was dynamically loaded. Applying mask...');
            
            // Apply the mask now that the canvas elements exist
            setDelayedMask();
            
            // Now that the canvas builder is present, we can start watching for image swaps
            observeMediaChanges();
            
            // Stop watching the body for the canvas builder itself
            canvasBuilderObserver.disconnect();
            canvasBuilderObserver = null; // Clean up
            return; // We found it, stop looping
          }
        }
      }
    }
  });

  // Start observing the body for the dynamic injection of the canvas builder
  canvasBuilderObserver.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
  
  // ALSO check if the canvas builder was *already* on the page (e.g. cached)
  if (document.querySelector('.tpo_canvas_builder')) {
      console.log("LOG: Canvas builder was already present on DOM load.");
      applyAlphaMask();
      observeMediaChanges();
      canvasBuilderObserver.disconnect(); // Stop the body observer
      canvasBuilderObserver = null;
  }
});







  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
